<script setup lang="ts">
    import { onMounted } from 'vue';

    onMounted(() => {
        const scrollBtn = document.getElementById("scrollToTopBtn");

        if (scrollBtn) {
            window.addEventListener("scroll", () => {
                if (window.scrollY > 300) {
                    scrollBtn.style.display = "block";
                } else {
                    scrollBtn.style.display = "none";
                }
            });

            scrollBtn?.addEventListener("click", () => {
                window.scrollTo({
                    top: 0,
                    behavior: "smooth"
                });
            });
        }
    });
</script>

<template>
    <button id="scrollToTopBtn" title="Go to top">
        <NuxtImg src="/up-green-arrow.svg" height="30" width="30"/>
    </button>
</template>